import { useMemo } from 'react'
import { detectTimezone, listTimezones } from '@/lib/timezones.js'

export default function TimezoneSelect({ value, onChange, includeAuto = true, ...rest }) {
  const zones = useMemo(() => listTimezones(), [])
  const detected = useMemo(() => detectTimezone(), [])
  const valueInList = !value || zones.includes(value)

  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} {...rest}>
      {includeAuto && (
        <option value="">{detected ? `Auto (${detected})` : 'Auto'}</option>
      )}
      {!valueInList && value && (
        <option value={value}>{value} (custom)</option>
      )}
      {zones.map((zone) => (
        <option key={zone} value={zone}>{zone}</option>
      ))}
    </select>
  )
}
